import './style.css';

import {Map, View} from 'ol';
import Overlay from 'ol/Overlay.js';
import {defaults as defaultControls} from 'ol/control.js';
import MousePosition from 'ol/control/MousePosition.js';
import {format} from 'ol/coordinate.js';
import proj4 from 'proj4';
import {transform} from 'ol/proj';
import moment from 'moment/moment';
/*bingMapRoadOnDemand, bingMapAerial, bingMapAerialWithLabelsOnDemand,*/
import {proyeccion3857, proyeccion4326, proyeccion32717, proyeccion32718, proyeccion32719, centroid3857, formatoSalidaJson, formatoSalidaGeoJson, nombresColumnas} from './assets/js/configuracion';
import {arcgisLightGray, arcgisWorldTopo, arcgisWorldImagery, osm, cartaNacional100K, cartaNacional100KACT, cartaNacional25K} from './assets/js/capasBase.js';
import {capitales, ccppAsentamientosDispersos, tiempoDesplazamientoCapitalCercano, ccppCategorizacionRecategorizacion, ccppReconocimientoLey,
  densidadCrecimientoPoblacional, densidadCrecimientoPobCcpp,
  densidadViviendas, densidadServiciosFinancieros, densidadComercio, densidadMercado, densidadInmobiliario, densidadDelitos,
  flujoTrabajo100a1500, flujoTrabajo1500a5000, flujoTrabajo5000a10000, flujoTrabajo10000a25000, flujoTrabajo25000,
  flujoEstudiantes100a1000, flujoEstudiantes1000a3500, flujoEstudiantes3500a7000, flujoEstudiantes7000a13000, flujoEstudiantes13000,
  vabLima, vabCallao, vabTotal,
  coberturaMovOper, coberturaMovTipo,
  viasNacional, viasDepartamental, viasVecinal, aerodromos,
  comunidadesNativas, comunidadesCampesinas,
  evaluacionRiesgos, zonasRiesgosNoMitigable,
  inventarioInundaciones, tramosCriticosInundaciones, puntosCriticosInundaciones, areasExposicionInundaciones,
  areasExposicionMovimientoMasa, zonasCriticasMovimientoMasa, inventarioMovimientoMasa,
  serviciosEducativos, localesEducativos, institucionesPrestadorasServiciosSalud,
  limiteDistrital, limiteProvincial, limiteDepartamental} from './assets/js/capasTematicas.js'; //OMD
import { dibujoGeometria } from './assets/js/graficarMapa.js';
import { vectorCalculo, modificarEstilo } from './assets/js/calcularPerimetroSuperficie.js';

proj4.defs('EPSG:4326','+proj=longlat +datum=WGS84 +no_defs +type=crs');
proj4.defs('EPSG:32717','+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs +type=crs');
proj4.defs('EPSG:32718','+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs +type=crs');
proj4.defs('EPSG:32719','+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs +type=crs');

global.activoInformacion='';

function closeAllPopups() {
  const allPopups = document.querySelectorAll('.custom-menu-widget-item-popup');
  allPopups.forEach(popup => {
    popup.style.display = 'none';
  });
}//OMD

const popup = document.getElementById('popup'),
contenido = document.getElementById('popup-content'),
cerrar = document.getElementById('popup-closer');

const cubrir = new Overlay({
  element: popup,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
});

const mousePosicion = new MousePosition({
  coordinateFormat: function(e) {
    let zona ='', este='', norte='', texto='', coordenada;
    const e1 = transform(e, proyeccion3857, proyeccion4326);

    if (e1[0] >= -81.497 && e1[0] < -78.000) {
      const punto = { x: e1[0], y: e1[1] };
      coordenada = proj4(proyeccion4326, proyeccion32717, punto);            
      zona = '&nbsp;<b>UTM Zona: 17S </b>';
    }
    if (e1[0] >= -78.000 && e1[0] < -72.000) {
      const punto = { x: e1[0], y: e1[1] };
      coordenada = proj4(proyeccion4326, proyeccion32718, punto);       
      zona = '&nbsp;<b>UTM Zona: 18S </b>';
    }
    if (e1[0] >= -72.000 && e1[0] <= -68.504) {
      const punto = { x: e1[0], y: e1[1] };
      coordenada = proj4(proyeccion4326, proyeccion32719, punto);       
      zona = '&nbsp;<b>UTM Zona: 19S </b>';
    }
    if (coordenada !== undefined) {
      este = new Intl.NumberFormat('es-PE').format(coordenada.x.toFixed(2)).toString();
      norte = new Intl.NumberFormat('es-PE').format(coordenada.y.toFixed(2)).toString();
      texto= format(e1, '<b>GCS Latitud</b>: {y},&nbsp;<b>Longitud</b>: {x}', 4) + '&nbsp;' + zona + '&nbsp;<b>Este</b>: '+ este + 'm.&nbsp;<b>Norte</b>: ' + norte + 'm.';
    }
    else texto = format(e1, '<b>GCS Latitud</b>: {y},&nbsp;<b>Longitud</b>: {x}', 4) + '&nbsp;'
    return texto;
  },
  projection: proyeccion3857,
  target: document.getElementById('mouse-position'),
});

global.vista = new View({
  projection: proyeccion3857,
  center: centroid3857, 
  zoom: 5
});
/*bingMapRoadOnDemand, bingMapAerial, bingMapAerialWithLabelsOnDemand,*/
global.mapa = new Map({
  target: 'map',
  layers: [arcgisLightGray, arcgisWorldTopo, arcgisWorldImagery, osm, cartaNacional100K, cartaNacional100KACT, cartaNacional25K,
    tiempoDesplazamientoCapitalCercano, comunidadesNativas, comunidadesCampesinas,
    densidadCrecimientoPoblacional, densidadCrecimientoPobCcpp,
    densidadViviendas, densidadServiciosFinancieros, densidadComercio, densidadMercado, densidadInmobiliario, densidadDelitos,
    flujoTrabajo100a1500, flujoTrabajo1500a5000, flujoTrabajo5000a10000, flujoTrabajo10000a25000, flujoTrabajo25000,
    flujoEstudiantes100a1000, flujoEstudiantes1000a3500, flujoEstudiantes3500a7000, flujoEstudiantes7000a13000, flujoEstudiantes13000,
    vabLima, vabCallao, vabTotal,
    coberturaMovOper, coberturaMovTipo,
    ccppAsentamientosDispersos, capitales, ccppCategorizacionRecategorizacion, ccppReconocimientoLey,
    viasNacional, viasDepartamental, viasVecinal, aerodromos,
    evaluacionRiesgos, zonasRiesgosNoMitigable,
    inventarioInundaciones, tramosCriticosInundaciones, puntosCriticosInundaciones, areasExposicionInundaciones,
    areasExposicionMovimientoMasa, zonasCriticasMovimientoMasa, inventarioMovimientoMasa,
    serviciosEducativos, localesEducativos, institucionesPrestadorasServiciosSalud,
    limiteDistrital, limiteProvincial, limiteDepartamental, dibujoGeometria],
  controls: defaultControls({
    attribution: false,
    zoom: true,
  }).extend([mousePosicion]),
  overlays: [cubrir],
  view: vista
}); //OMD

//
// Boton Fullscreen
//
function activarFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) { /* Firefox */
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) { /* IE/Edge */
    element.msRequestFullscreen();
  }
}

var btnFullscreen = document.getElementById('btnFullscreen');
btnFullscreen.addEventListener('click', function() {
  activarFullscreen(global.mapa.getTargetElement());
});

//
// CONTROLES DE ACCIONES DEL VISOR
//
// 1. Vista General
var vistaGeneral = document.getElementById('vistaGeneral');
vistaGeneral.addEventListener('click', function() {
  closeAllPopups();
  global.vista.setCenter(centroid3857);
  //if(global.mapa.getSize()[0] > 1296) global.vista.setZoom(6);
  //else global.vista.setZoom(5.4);
  if(global.mapa.getSize()[1] <= 778) global.vista.setZoom(5.4);
  else global.vista.setZoom(6);
});

// 3. Filtro Territorial
import './assets/js/filtroTerritorial.js';

// 4. Graficar sobre el mapa

// 5. Cargar tu información SHP, CSV
import './assets/js/cargarArchivo.js';

// 6. Conectar a un servicio web de mapa
import './assets/js/cargarServicioWeb.js';

// 7. Ubicar coordenadas
import './assets/js/ubicarCoordenadas.js';

// 8. Obtener coordenadas
import './assets/js/obtenerCoordenadas.js';

// 9. Cálculo de superficie, perímetro
global.mapa.addLayer(vectorCalculo);
global.mapa.addInteraction(modificarEstilo);

// 10. Imprimir
import './assets/js/imprimir.js';

// 11. Envíanos sugerencias

// 12. Enlace de interes
import './assets/js/enlacesInteres.js';

//window.addEventListener('load', function() {
//  setTimeout(function() {
//    document.getElementById('loading-screen').style.display = 'none';
//    document.getElementById('contenidoSidebar').style.display = 'block';
//    document.getElementById('wrapper').style.display = 'block';
//  }, 1000);
//});

var aceptarCondicionesUso = document.getElementById('aceptarCondicionesUso');
aceptarCondicionesUso.addEventListener('click', function() {
  document.getElementById('loading-screen').style.display = 'none';
  document.getElementById('contenidoSidebar').style.display = 'block';
  document.getElementById('wrapper').style.opacity = '1';
});

moment.updateLocale('es', {
  months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
  monthsShort : 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
  weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
  weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
  weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
  longDateFormat : {
      LT : 'H:mm',
      LTS : 'H:mm:ss',
      L : 'DD/MM/YYYY',
      LL : 'D [de] MMMM [de] YYYY',
      LLL : 'D [de] MMMM [de] YYYY H:mm',
      LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
  },
});

//
// Evento de identificar
//
cerrar.onclick = function () {
  cubrir.setPosition(undefined);
  cerrar.blur();
  return false;
};

global.mapa.on('singleclick', function(e) {
  
  const resolucionVista = /** @type {number} */ (global.vista.getResolution());
  var urlInterno = '';
  const capaTematica = global.mapa.getLayers().getArray().find(layer => layer.get('id') === activoInformacion) || null;
  
  if (capaTematica != null) {
    if (activoInformacion === 'comunidadesNativas' || activoInformacion === 'comunidadesCampesinas') {
      urlInterno = capaTematica.getSource().getFeatureInfoUrl(
        e.coordinate,
        resolucionVista,
        proyeccion3857,
        {'INFO_FORMAT': formatoSalidaGeoJson}
      );
    } else {
      urlInterno = capaTematica.getSource().getFeatureInfoUrl(
        e.coordinate,
        resolucionVista,
        proyeccion3857,
        {'INFO_FORMAT': formatoSalidaJson}
      );
    }
  }
  
  if (urlInterno){ //debugger
    //console.log(urlInterno);
    fetch(urlInterno)
      .then((response) => response.json())
      .then((json) => {
        var datos = json.features[0].properties;
        //if (json && Array.isArray(json.features) && json.features.length > 0) {
          //var datos = json.features[0].properties;
        //} else {
          //console.error("El objeto JSON no tiene features o está vacío:", json);
        //}
        var tabla ='<table>';
        for (const i in datos) {
          var id = nombresColumnas.find(e => e.id === i);
          if (id !== undefined) {
            if (i === 'gid') continue;
            else if (activoInformacion === 'tiempoDesplazamientoCapitalCercano' && i === 'direccion') continue; //OMD
            else if (activoInformacion === 'densidadViviendas') continue; //OMD
            else if (i === 'rango') { //OMD
              tabla += '<tr><td><strong>Rango</strong></td><td>:</td><td>' + formatoExponente(datos[i]) + '</td></tr>'; //OMD
            } //OMD
            else if (i === 'nivel') { //OMD
              tabla += '<tr><td><strong>Nivel</strong></td><td>:</td><td>' + datos[i] + '</td></tr>'; //OMD
            } //OMD
            else if (i === 'dep_entran') { //OMD
              var dpto2 = datos[i]; //OMD
            } //OMD
            else if (i === 'prov_entra') { //OMD
              var prov2 = datos[i]; //OMD
            } //OMD
            else if (i === 'dep_salen') { //OMD
              var dpto1 = datos[i]; //OMD
            } //OMD
            else if (i === 'prov_salen') { //OMD
              var prov1 = datos[i]; //OMD
            } //OMD
            else if (i === 'dist_entra') { //OMD
              tabla += '<tr><td><strong>Distrito 2</strong></td><td>:</td><td>' + datos[i] + ' (' + dpto2 + ' / ' + prov2 + ')</td></tr>'; //OMD
            } //OMD
            else if (i === 'dist_salen') { //OMD
              tabla += '<tr><td><strong>Distrito 1</strong></td><td>:</td><td>' + datos[i] + ' (' + dpto1 + ' / ' + prov1 + ')</td></tr>'; //OMD
            } //OMD
            else if ((activoInformacion === 'ccppCategorizacionRecategorizacion' || activoInformacion === 'ccppReconocimientoLey') && i === 'viv') continue; //OMD
            else if ((activoInformacion === 'ccppAsentamientosDispersos' || activoInformacion === 'ccppCategorizacionRecategorizacion' || activoInformacion === 'ccppReconocimientoLey') && (i === 'pob' || i === 'pob_2017')) { //OMD
              tabla += '<tr><td><strong>' + ((id != undefined)? id.nombre : i) + '</strong></td><td>:</td><td>' + datos[i] + ' hab.</td></tr>'; //OMD
            } //OMD
            else if (i === 'capital') { //OMD
              var esCapital = datos[i]; //OMD
              if (esCapital === null) continue; //OMD
              else if (esCapital === '1' || esCapital === '2' || esCapital === '3') { //OMD
                tabla += '<tr><td><strong>' + ((id != undefined)? id.nombre : i) + '</strong></td><td>:</td><td>Si</td></tr>'; //OMD
              } //OMD
            } //OMD
            else if (activoInformacion === 'aerodromos' && i === 'nombre') continue; //OMD
            else if ((activoInformacion === 'viasNacional' || activoInformacion === 'viasDepartamental' || activoInformacion === 'viasVecinal') && i === 'estado') continue; //OMD
            else if (activoInformacion === 'coberturaMovOper' && i === 'layer') continue; //OMD
            else if (activoInformacion === 'coberturaMovTipo' && i === 'emoperador') continue; //OMD
            else if (activoInformacion === 'evaluacionRiesgos' && i === 'estado') continue; //OMD
            else if (activoInformacion === 'zonasRiesgosNoMitigable' && i === 'url1') continue; //OMD
            else if (activoInformacion === 'inventarioInundaciones' && (i === 'tip_peligr' || i === 'nomb_rio_q' || i === 'url_documento' || i === 'fecha_actu' || i === 'observ' || i === 'descrip' || i === 'infraestru' || i === 'medid_prev' || i === 'n_peligro' || i === 'paraje' || i === 'descripcio') && (datos[i] === '-' || datos[i] === '' || datos[i] === ' ' || datos[i] === '.')) continue; //OMD
            else if (activoInformacion === 'tramosCriticosInundaciones' && (i === 'observ' || i === 'n_peligro' || i === 'descrip') && (datos[i] === '' || datos[i] === ' ')) continue; //OMD
            else if (activoInformacion === 'puntosCriticosInundaciones' && (i === 'nom_cuenca' || i === 'observ' || i === 'nomb_rio_q' || i === 'ubigeo' || i === 'descrip' || i === 'medid_prev' || i === 'n_peligro' || i === 'tip_peligr' || i === 'fecha' || i === 'fecha_doc')) continue; //OMD
            else if (activoInformacion === 'areasExposicionInundaciones' && (i === 'ubigeo' || i === 'departamento' || i === 'provincia' || i === 'distrito' || i === 'observ' || i === 'des_inu' || i === 'nom_rio' || i === 'nom_dep' || i === 'nom_prov' || i === 'nom_dist' || i === 'observ' || i === 'des_inu' || i === 'nom_lugar' || i === 'url1' || i === 'tipo_inu2') && (datos[i] === ' ' || datos[i] === '-')) continue; //OMD
            else if (activoInformacion === 'areasExposicionMovimientoMasa' && (i === 'nom_prov' || i === 'nom_dist' || i === 'peligro_esp' || i === 'observ' || i === 'fuente' || i === 'peligro_es' || i === 'descrip' || i === 'url1' || i === 'ubigeo' || i === 'nom_lugar') && (datos[i] === '   ' || datos[i] === '  ' || datos[i] === ' ' || datos[i] === '' || datos[i] === '-' || datos[i] === '.')) continue; //OMD
            else if (activoInformacion === 'zonasCriticasMovimientoMasa' && (i === 'fecha' || i === 'fecha_doc')) continue; //OMD
            else if ((activoInformacion === 'zonasRiesgosNoMitigable' || activoInformacion === 'tramosCriticosInundaciones' || activoInformacion === 'puntosCriticosInundaciones' || activoInformacion === 'areasExposicionInundaciones' || activoInformacion === 'areasExposicionMovimientoMasa') && i === 'fecha_doc') {
              if (datos[i] != null) {
                var date = moment(datos[i], 'YYYY-MM-DD');
                tabla += '<tr><td><strong>Fecha de información</strong></td><td>:</td><td>' + date.format('L') + '</td></tr>';
              }
            }
            else if (i === 'fecha' || i === 'fecha_fin') {
              var date = moment(datos[i], 'YYYY-MM-DD');
              tabla += '<tr><td><strong>Fecha</strong></td><td>:</td><td>' + date.format('LL') + '</td></tr>';
            }
            else if (i === 'fecha_inst') {
              var date = moment(datos[i], 'YYYY-MM-DD');
              tabla += '<tr><td><strong>Fecha del instrumento</strong></td><td>:</td><td>' + date.format('LL') + '</td></tr>';
            }
            else if (i === 'fec_inic_o') {
              var date = moment(datos[i], 'YYYY-MM-DD');
              tabla += '<tr><td><strong>Fecha inicio actividad</strong></td><td>:</td><td>' + date.format('LL') + '</td></tr>';
            }
            else if (i === 'direccion' || i === 'url' || i === 'url1') {
              var url = datos[i];
              if (url != null) tabla += '<tr><td><strong>'+ id.nombre +'</strong></td><td>:</td><td><i class="bi bi-file-pdf-fill"></i>&nbsp;<a href="'+ url + '" target="_blank" rel="noopener noreferrer"">Descargar</a></td></tr>';
            }
            else if (i === 'vab_total') {
              tabla += '<tr><td><strong>VAB estimado</strong></td><td>:</td><td>' + redondearDosDecimales(datos[i]) + '</td></tr>';
            }
            else {
              if (datos[i] === null) continue;
              tabla += '<tr><td><strong>' + ((id != undefined)? id.nombre : i) + '</strong></td><td>:</td><td>' + datos[i] + '</td></tr>';
            }
          }
        }
        tabla += '</table>';
        contenido.innerHTML = '<div>' + tabla + '</div>';
        cubrir.setPosition(e.coordinate);
      });
  }
});

function formatoExponente(texto) { //OMD
  if (texto.endsWith("km2")) {
    return texto.slice(0, -1) + '<sup>2</sup>';
  }
  return texto;
  //return texto.replace(/(\d)$/, '<sup>$1</sup>');
} //OMD

function ajustarTamaño() {
  //console.log(global.mapa.getSize()[1]);
  //if(global.mapa.getSize()[1] > 575) 
  if (global.mapa.getSize()[1] <= 778) {
    global.vista.setZoom(5.4);
    document.body.classList.toggle('sb-sidenav-toggled');
    localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
  }
  else global.vista.setZoom(6);
}

function redondearDosDecimales(valor) {
  if (isNaN(valor) || valor === null || valor === '') {
    return '-';
  }
  return Number.parseFloat(valor).toFixed(2);
}

//window.addEventListener('resize', ajustarTamaño);
ajustarTamaño();